import { useRouter, useRoute } from "vue-router";
import { useToastStore } from "@S/toast";
import { useUserStore } from "@S/user";
import helpers from "@L/helpers";

export function useGlobalErrorHandler() {
  const router = useRouter();
  const route = useRoute();
  const toastStore = useToastStore();
  const userStore = useUserStore();
  function handleError(e) {
    const extractedError = helpers.extractAlert(e);
    if (route.name !== "signin") {
      toastStore.show(extractedError.alert.message, "error");
    }
    if (extractedError.redirect) {
      userStore.setUser(null);
      router.push({ name: extractedError.redirect });
    }
  }
  return { handleError };
}
